// GENERATED by docs/content/learn/tools/gen-app-articles.mjs from the same articles (titles only) — do not edit by hand; edit the Markdown and re-run.
export type LearnBasicsTitle = {
  id: string;
  title: { en: string; ru: string };
};

/** The 25 Basics articles in display order — the portal's pickers and the film names read this. */
export const LEARN_BASICS: readonly LearnBasicsTitle[] = [
  { id: 'what-is-cbt', title: { en: 'What is CBT?', ru: 'Что такое КПТ?' } },
  {
    id: 'abc',
    title: {
      en: 'Thoughts, feelings and actions: the ABC model',
      ru: 'Мысли, чувства и действия: ABC-модель',
    },
  },
  {
    id: 'thinking-traps',
    title: {
      en: 'Automatic thoughts and thinking traps',
      ru: 'Автоматические мысли и ловушки мышления',
    },
  },
  {
    id: 'testing-a-thought',
    title: { en: 'Testing a thought', ru: 'Тестирование мысли' },
  },
  { id: 'coping-cards', title: { en: 'Coping cards', ru: 'Копинг-карточки' } },
  {
    id: 'core-beliefs',
    title: {
      en: 'Core beliefs and the downward arrow',
      ru: 'Глубинные убеждения и «Падающая стрела»',
    },
  },
  {
    id: 'schema-modes',
    title: {
      en: 'Schema modes: the parts that take over',
      ru: 'Режимы схем: части, которые берут верх',
    },
  },
  {
    id: 'vicious-cycles',
    title: {
      en: 'Vicious cycles: how a problem keeps itself going',
      ru: 'Поддерживающие циклы: что подпитывает проблему',
    },
  },
  {
    id: 'avoidance-and-exposure',
    title: { en: 'Avoidance and exposure', ru: 'Избегание и экспозиция' },
  },
  {
    id: 'behavior-experiments',
    title: { en: 'Behavior experiments', ru: 'Поведенческие эксперименты' },
  },
  {
    id: 'functional-analysis',
    title: {
      en: 'Functional analysis: what a behavior does',
      ru: 'Функциональный анализ: что даёт поведение',
    },
  },
  {
    id: 'worry',
    title: {
      en: 'Worry and the worry tree',
      ru: 'Беспокойство и дерево принятия решений',
    },
  },
  {
    id: 'getting-active',
    title: {
      en: 'Low mood and getting active',
      ru: 'Подавленность и возвращение к активности',
    },
  },
  {
    id: 'solving-problems',
    title: {
      en: 'Solving a problem step by step',
      ru: 'Решение проблемы шаг за шагом',
    },
  },
  {
    id: 'people-and-support',
    title: {
      en: 'People, support and asking for help',
      ru: 'Люди, поддержка и просьба о помощи',
    },
  },
  {
    id: 'self-kindness',
    title: {
      en: 'Being on your own side: self-kindness',
      ru: 'Быть на своей стороне: доброта к себе',
    },
  },
  {
    id: 'sleep',
    title: {
      en: 'Sleep: what helps and what keeps you awake',
      ru: 'Сон: что помогает уснуть, а что мешает',
    },
  },
  {
    id: 'staying-well',
    title: {
      en: 'Staying well: your plan for setbacks',
      ru: 'Как сохранить результат: план на случай спада',
    },
  },
  {
    id: 'values',
    title: { en: 'What matters to you', ru: 'Что для Вас по-настоящему важно' },
  },
  {
    id: 'motivation',
    title: {
      en: 'Motivational interviewing: mixed feelings',
      ru: 'Мотивационное интервьюирование: когда трудно решиться на изменения',
    },
  },
  {
    id: 'mood-check-in',
    title: {
      en: 'Noticing your mood: check-ins and diary card',
      ru: 'Как замечать настроение: записи и дневник',
    },
  },
  {
    id: 'mindfulness',
    title: {
      en: 'Why practice mindfulness',
      ru: 'Зачем практиковать осознанность',
    },
  },
  {
    id: 'safety-plan',
    title: {
      en: 'Planning for hard moments: your safety plan',
      ru: 'Ваш план безопасности на трудные моменты',
    },
  },
  {
    id: 'questionnaires',
    title: {
      en: "Questionnaires: what scores show, and don't",
      ru: 'Опросники: что показывают баллы, а что — нет',
    },
  },
  {
    id: 'personal-boundaries',
    title: {
      en: 'Boundaries and saying no',
      ru: 'Границы и умение говорить «нет»',
    },
  },
];
